import { BorderType } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { getPcInjectedService } from '@src/framework/workbench/util/injector-service';
import { ChartService } from '@src/framework/workbench/common/service/chart-service';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import type { IItems } from '../form.interface';
/**
 * 图表线条专项。边框区域需要隐藏的设置项。
 * @param model 所选元素
 * @returns
 */
export const getChartLineHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    const chartModel = model as IChartModel;
    if (chartModel.type !== UIModelType.CHART && !chartModel.selectedElement) return {};
    const showMarker = (getPcInjectedService(ChartService) as ChartService).showMarkerPanel();
    const element = chartModel.getSelectedElementProperty(showMarker);
    if (!element?.getBorder()) return {};
    const borderType = element?.getBorder?.()?.getBorderType();
    return {
        [ChartFormItemKey.CHART_LINE_WIDTH]:
            () => (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill),
        [ChartFormItemKey.CHART_LINE_COLOR]:
            () => (borderType !== BorderType.SolidFill),
        [ChartFormItemKey.CHART_LINE]:
            () => ((borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill)),
        [ChartFormItemKey.CHART_LINE_OPACITY]:
            () => (borderType !== BorderType.SolidFill),
        [ChartFormItemKey.CHART_LINE_SPACE]: () => borderType !== BorderType.SolidFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_LINEAR_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_RADIAL_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_ANGLE]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_DIRECTION]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_TYPE_TEXT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_ANGLE_TEXT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_DIRECTION_TEXT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_BAR]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_LINE_GRADUAL_OPACITY]: () => borderType !== BorderType.GradualFill,
    };
};

export const getChartGlobalLineHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    const chartModel = model as IChartModel;
    if (chartModel.type !== UIModelType.CHART) return {};
    if (!chartModel.selected) return {};
    const element = chartModel.getChartSpaceProperty();
    if (!element?.getBorder()) return {};
    const borderType = element?.getBorder?.()?.getBorderType();
    return {
        [ChartFormItemKey.CHART_GLOBAL_LINE_WIDTH]:
            () => (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill),
        [ChartFormItemKey.CHART_GLOBAL_LINE_COLOR]:
            () => (borderType !== BorderType.SolidFill),
        [ChartFormItemKey.CHART_GLOBAL_LINE]:
            () => ((borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill)),
        [ChartFormItemKey.CHART_GLOBAL_LINE_OPACITY]:
            () => (borderType !== BorderType.SolidFill),
        [ChartFormItemKey.CHART_GLOBAL_LINE_SPACE]: () => borderType !== BorderType.SolidFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_LINEAR_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_RADIAL_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_ANGLE]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_DIRECTION]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_TYPE_TEXT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_ANGLE_TEXT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_DIRECTION_TEXT]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_BAR]: () => borderType !== BorderType.GradualFill,
        [ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_OPACITY]: () => borderType !== BorderType.GradualFill,
    };
};
